module.exports = __webpack_public_path__ + "static/media/2DGACM9.406f8556.jpg";